import { combineReducers } from 'redux';
import { headerNavLocation, headerNavStyle, menuState, slugState, routerState } from './header_nav_location';
import { homeCounter, homeImagesLoaded } from './home_counter';
import { categorySelector } from './category_selected';
import { staticContent, staticContentHasErrored, staticContentIsLoading } from './static_content';
import { scrollState, resizeState, scrollDirectionState, heroState } from './r_window_data';
import { categoryNavState, categoryNavSubRoute, categoryNavPageState } from './r_cateogory_nav';
import { setVideoState } from './r_media_controls';

const reducers = combineReducers({
  nav_location: headerNavLocation,
  header_style: headerNavStyle,
  scroll_state: scrollState,
  scroll_direction: scrollDirectionState,
  past_hero: heroState,
  window_dimensions: resizeState,
  menu_state: menuState,
  route: slugState,
  router: routerState,
  current_category_slug: categoryNavSubRoute,
  current_sub_category: categorySelector,
  category_nav_page: categoryNavPageState,
  category_nav: categoryNavState,
  video_state: setVideoState,
  homeCounter,
  homeImagesLoaded,
  staticContent,
  staticContentHasErrored,
  staticContentIsLoading
});

export default reducers;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js